<template>
  <div :class="$style.check_wrap">
    <img
      v-if="show_new"
      :class="$style.newPopIcon"
      src="/img/default/new-pop.png" />
    <div :class="$style.check_list">
      <div :class="$style.check">受信日時</div>
      <div :class="[$style.value, $style.type]">
        <p>{{ formatTimestamp(message_group_data.created_at, 'YYYY/MM/DD（ddd） HH:mm') }}</p>
      </div>
    </div>
    <div :class="$style.user_box_wrap">
      <user-box
        v-if="counselor"
        :user="counselor"
        :showAge="false"
      />
    </div>
    <div>
      <div :class="[$style.value, $style.type, $style.messageArea]" class="n2br">
        <p>{{ message_group_data.messages[0].message }}</p>
      </div>
    </div>
    <btn-container>
      <basic-btn
        tag="button"
        v-on:click="clickReserve"
      >この先生にオンライン相談する</basic-btn>
    </btn-container>
    <spacer :y="3"/>
  </div>
</template>

<script>
import UserBox from '@/views/components/UserBox.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import BasicBtn from '@/views/components/BasicBtn.vue';
import Spacer from '@/views/components/Spacer.vue';

import cf from '@/mixins/commonFunctions';

export default {
  name: 'CounselorMessageBoxRich',
  mixins: [
    cf,
  ],
  components: {
    UserBox,
    BtnContainer,
    BasicBtn,
    Spacer,
  },
  props: {
    message_group_data: {
      type: Object,
      required: true,
    },
    show_new: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      counselor: null,
    };
  },
  created() {
    // 医師心理士情報を取得
    this.counselor = this.getCounselorDetail();
  },
  methods: {
    async getCounselorDetail() {
      const response = await this.axios({
        method: 'GET',
        url: '/v1/user/get/detail',
        params: {
          id: this.message_group_data.user_id,
        },
      });
      this.counselor = response.data.data;
    },

    clickReserve() {
      // 予約画面へ遷移
      // /?target=counselor&tab=online
      this.$router.push({
        path: '/',
        query: {
          tab: 'online',
          target: 'counselor',
        },
      });
      cf.saveTabState({ tab: 'online' }); // タブの状態を保存
    },
  },
};
</script>

<style lang="scss" module>
.check_wrap {
  position: relative;
  flex-wrap: wrap;
  align-items: center;
  // グレーの枠線、角丸
  border: 3px solid var(--gray-sub);
  border-radius: 8px;
  padding: 12px;

  @include sm-view {
     flex-direction: column;
     align-items: flex-start;
  }
}

.user_box_wrap {
  margin-top: 10px;
  width: 100%;
}
.check_list {
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
  // font-size: 14px;
  @include sm-view {
    font-size: 13px;
    display: block;
  }
  @include xs-view {
    display: block;
  }
}

.check {
  background-color: var(--gray-sub);
  font-weight: bold;
  border-radius: 4px;
  padding: 4px 0;
  width: 140px;
  text-align: center;
  margin-right: 12px;
  @include sm-view {
    width: 100%;
    text-align: left;
    padding: 0.5em;
  }
}

.value {
  flex: 1;
  margin-top: 4px;
  // font-weight: bold;

  @include sm-view {
    padding-left: 3%;
  }

  &.type {
    display: flex;
    flex-wrap: wrap;
    p {
      &:not(:last-child) {
        &::after {
          margin: 0 5px;
          content: '/';

        }
      }
    }
  }
}

.new {
  position: absolute;
  top: -10px;
  left: auto;
  right: -8px;
  z-index: 1;
  background-color: var(--pink);
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 4px;

  &_wrap {
    position: relative;
  }

  @include sm-view {
    padding: 3px 7px 2px;
    font-size: 11px;
    right: -4px;
    top: -4px;
  }
}

.messageArea {
  position: relative;
  background: #E0ECC7; // 薄緑
  border-radius: 24px;
  border: 3px solid #99ab4e; // 枠線は、背景色よりやや濃い緑にする
  padding: 16px 20px;
  margin: 1rem 0;
  min-width: 80px;
  max-width: 100%;
  word-break: break-all;
}

.newPopIcon {
  position: absolute;
  top: -25px;
  right: -10px;
  width: 100px;
  z-index: 1;
}
</style>
